import React from 'react';
import { Typography } from '@mui/material';
import { ts } from 'src/utils/translate';
import { theme } from 'src/theme/mui-theme';
import { BaseDialog } from 'src/components/BaseDialog/BaseDialog';

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    projectName: string;
};

const ProjectDuplicateDialog = ({ open, onClose, onConfirm, projectName }: Props) => {
    return (
        <BaseDialog
            open={open}
            onClose={onClose}
            title={ts('warning', 'Warning!')}
            maxWidth="xs"
            cancelLabel={ts('plt_cancel', 'Cancel')}
            actionLabel={ts('plt_ok', 'OK')}
            onAction={onConfirm}
        >
            <Typography sx={{ fontWeight: 300, color: theme.palette.text.secondary, fontSize: 13 }}>
                {ts('tree_clone_confirmation_please', 'Please confirm cloning project {0}.', [
                    { template: '{0}', value: projectName || '' },
                ])}
            </Typography>
        </BaseDialog>
    );
};

export default ProjectDuplicateDialog;
